import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  ActionMenuPuestosSelected,
  MenuSelectedPuestosEnum,
} from "../../types/PuestosTypes.ts";

const initialState = {
  menuSelected: MenuSelectedPuestosEnum.razonsocial,
  total: 0,
  sucursalesList: [],
  page: 0,
  limit: 50,
  loading: true,
  param: "",
  query: "",
  fetch: false,
  showModal: false,
  currentRecord: {
    id: -1,
    name: "",
  },
  deleteModal: false,
  positionsOriginal: [] as any[],
  positions: [] as any[],
  sortBy: "id",
  defaultSort: "asc",
};

const puestosSlice = createSlice({
  name: "sucursalesList",
  initialState,
  reducers: {
    setMenu: (state, action: ActionMenuPuestosSelected) => {
      state.menuSelected = action.payload;
      state.page = 0;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setSucursales: (state, action: PayloadAction<[]>) => {
      state.sucursalesList = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTotal: (state, action: PayloadAction<number>) => {
      state.total = action.payload;
    },
    setParam: (state, action: PayloadAction<string>) => {
      state.param = action.payload;
      state.page = 0;
    },
    setFetch: (state, action: PayloadAction<boolean>) => {
      state.fetch = !state.fetch;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
      state.page = 0;
    },
    setShowModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
    setCurrentRecord: (
      state,
      action: PayloadAction<{ id: number; name: string }>
    ) => {
      state.currentRecord = action.payload;
    },
    setDeleteModal: (state, action: PayloadAction<boolean>) => {
      state.deleteModal = action.payload;
    },
    setPositions: (state, action: PayloadAction<any[]>) => {
      state.positions = action.payload;
    },
    setPositionsOriginal: (state, action: PayloadAction<any[]>) => {
      state.positionsOriginal = action.payload;
    },
    resetState: (state) => {
      state.total = 0;
      state.sucursalesList = [];
      state.page = 0;
      state.limit = 50;
      state.loading = true;
      state.param = "";
      state.query = "";
      state.fetch = false;
      state.showModal = false;
      state.currentRecord = {
        id: -1,
        name: "",
      };
      state.deleteModal = false;
      state.positionsOriginal = [];
      state.positions = [];
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setDefaultSort: (state, action: PayloadAction<string>) => {
      state.defaultSort = action.payload;
    },
  },
});

export const {
  setMenu,
  setPage,
  setLimit,
  setSucursales,
  setLoading,
  setTotal,
  setParam,
  setFetch,
  setQuery,
  setShowModal,
  setCurrentRecord,
  setDeleteModal,
  setPositions,
  setPositionsOriginal,
  resetState,
  setSortBy,
  setDefaultSort,
} = puestosSlice.actions;

export default puestosSlice.reducer;
